import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Header from "../../global/Header";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import ButtonBar from "../../components/ButtonBar";
import CardList from "../../components/CardList";
import ImageViewer from "../../components/ImageViewer";
import Slider from "../../components/Slider";
import Section from "../../components/Section";
import Heading from "../../components/Heading";
import Essay from "../../components/Essay";
import Footer from "../../global/Footer";
import {
  dark,
  light,
  aboutValue,
  servicesButtons,
  teamButtons,
  storyImages,
  coreProfiles,
  testimonials,
  competences,
  value,
  endButtons,
  aboutIntroHeading,
  aboutIntroEssay,
  aboutWhoHeading,
  aboutWhoEssay,
  aboutStoryHeading,
  aboutStoryEssay,
  aboutStoryEssay2,
  aboutTeamHeading,
  aboutTeamEssay,
  aboutWhatHeading,
  aboutWhatEssay,
  aboutValuesHeading,
  aboutValuesEssay,
  aboutTestimonialsHeading,
  aboutTestimonialsEssay,
  aboutMeetingHeading,
  aboutMeetingEssay,
  isTabWidth,
  aboutPicture,
  menuItems,
} from "../../data/database";
import { customColour } from "../../data/colour";
import ProfileCard from "../../components/ProfileCard";
import Testimonials from "../../components/Testimonials";

const linkLogo = [
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy/home",
  },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics/home",
  },
];

const lightCardBackground = `url(${light})`;
const GroupAbout = () => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <>
      {/* HERO SECTION */}
      <Box
        sx={{
          position: "relative",
          height: `${isTab ? "45vh" : "65vh"}`,
          overflow: "hidden",
          filter: "grayscale(95%) blur(0.5px) contrast(115%)",
          background:
            "radial-gradient(at bottom center, rgba(0,0,0,0.9) 12.5%, rgba(0,0,0,0.95) 25%, rgba(0,0,0,1) 37.5%)",
        }}
      >
        <img
          src={aboutPicture}
          alt="about"
          style={{
            objectFit: "contain",
            objectPosition: "bottom",
            width: "100%",
            height: "100%",
          }}
        />
        <Box
          sx={{
            width: "80%",
            position: "absolute",
            top: `${isTab ? "40%" : "15%"}`,
            left: "50%",
            color: customColour.white,
            transform: "translate(-50%, 0)",
          }}
        >
          <Heading
            heading={aboutIntroHeading}
            fontSize={isTab ? "1.25rem" : "3rem"}
            fontweight={isTab ? "400" : "200"}
          />
          <Essay
            paragraphs={aboutIntroEssay}
            textAlign={isTab ? "center" : "center"}
            fontSize={isTab ? "0.9rem" : "1rem"}
            marginTop={isTab ? "0.25rem" : "1rem"}
          />
        </Box>
      </Box>

      {/* WHO WE ARE Light*/}
      <Section
        // image={light}
        color={customColour.black}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutWhoHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutWhoEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <CardList
          data={aboutValue}
          gridTemplateColumns={isTab ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
          textFontSize={isTab ? "0.9rem" : "1rem"}
          backgroundImage={lightCardBackground}
        />
      </Section>

      {/* OUR STORY Dark*/}
      <Section
        image={dark}
        color={customColour.white}
        backgroundColor={customColour.darkBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutStoryHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutStoryEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ImageViewer
          images={storyImages}
          interval={5000}
          animation="zoom"
          aspectRatio={isTab ? 16 / 9 : 3 / 1}
        />
        <Essay
          paragraphs={aboutStoryEssay2}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
      </Section>

      {/* OUR TEAM Light */}
      <Section
        color={customColour.black}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutTeamHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutTeamEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ProfileCard
          data={coreProfiles}
          gridTemplateColumns={isTab ? `repeat(2, 1fr)` : `repeat(4, 1fr)`}
          nameTextSize={isTab ? "1rem" : "1.5rem"}
          subTextSize={isTab ? "0.6rem" : "0.75rem"}
          gap={isTab ? "0.75rem" : "2rem"}
        />
        <ButtonBar
          buttons={teamButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
          background="linear-gradient(
            to right bottom,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0.7)
            )"
        />
      </Section>

      {/* WHAT WE DO Dark*/}
      <Section
        image={dark}
        color={customColour.white}
        backgroundColor={customColour.darkBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutWhatHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutWhatEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <Slider
          slides={competences}
          aspectRatio={isTab ? 1 / 1 : 3 / 1}
          titleFontSize={isTab ? "1.25rem" : "2.5rem"}
          textFontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ButtonBar
          buttons={servicesButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
        />
      </Section>

      {/* OUR VALUES Light*/}
      <Section
        color={customColour.black}
        // image={light}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutValuesHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutValuesEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <CardList
          data={value}
          gridTemplateColumns={isTab ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
          textFontSize={isTab ? "0.9rem" : "1rem"}
          backgroundImage={`url(${light})`}
        />
      </Section>

      {/* TESTIMONIALS Dark*/}
      <Section
        image={dark}
        color={customColour.white}
        backgroundColor={customColour.darkBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutTestimonialsHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutTestimonialsEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <Testimonials
          testimonials={testimonials}
          interval={10000}
          textColor={customColour.white}
        />
      </Section>

      {/* CALL TO ENGAGE Light*/}
      <Section
        color={customColour.black}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={aboutMeetingHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={aboutMeetingEssay}
          textAlign="center"
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ButtonBar
          buttons={endButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
          background="linear-gradient(
            to right bottom,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0.7)
            )"
        />
      </Section>
    </>
  );
};

export default GroupAbout;
